import { RequestToDataIMPProps } from "@/types";
import { getDefaultParameters } from "./getDefaultParams";

export const requestDataIMP = ({ formData, name, amount, merchant_uid, custom_data }: RequestToDataIMPProps) => {
    const { co_id } = getDefaultParameters();
    const commonPaymentData = {
        merchant_uid: merchant_uid,
        amount: amount,
        name: name,
        buyer_name: formData.buyer,
        buyer_tel: formData.phoneNumber,
        m_redirect_url: `https://calendar.marginauto.kr/completeMobile?co_id=${co_id}`,
        custom_data,
    };

    if (formData.payMethod === "card") {
        const paymentData = {
            pg: "kcp",
            pay_method: "card",
            ...commonPaymentData,
        };

        return paymentData;
    }
    if (formData.payMethod === "naverpay") {
        const paymentData = {
            pg: "kcp.IP22M",
            pay_method: "naverpay",
            ...commonPaymentData,
        };

        return paymentData;
    }

    if (formData.payMethod === "kakaopay") {
        const paymentData = {
            pg: "kcp.IP22L",
            pay_method: "kakaopay",
            ...commonPaymentData,
        };

        return paymentData;
    }
};
